import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Edit from './Edit';

import {
  updateCPD,
  formFieldChange,
  getCPDDetails,
  closeModal,
} from './actions';

const mapStateToProps = state => ({
  ...state.staff.cpds.edit,
  filteredChunks: state.staff.cpds.list.filteredChunks,
  cities: state.staff.cities,
  fields: state.staff.cpds.list.fields,
  role: state.account.profile.role,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  getCPDDetails: () =>
    dispatch(
      getCPDDetails(
        ownProps.match.params.appname,
        ownProps.match.params.cpd,
        ownProps.match.params.memberbody,
      ),
    ),
  onSubmit: () =>
    dispatch(
      updateCPD(
        ownProps.match.params.cpd,
        ownProps.history,
        ownProps.match.params.appname,
        ownProps.match.params.memberbody,
      ),
    ),
  onRequestClose: role =>
    ownProps.match
      ? dispatch(
          closeModal(ownProps.match.params.appname, ownProps.history, role),
        )
      : null,
  onFieldChange: (isRequired, type, field, value, index) =>
    dispatch(formFieldChange(isRequired, type, field, value, index)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Edit),
);
